import React, { useState, useRef, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { CCard, CCol, CFormText, CButton, CRow } from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { useFileChange } from 'src/s3upload/use-file-change'
import ImageCropper from '../cms/imageCroper'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { checkPermissions, getImageCropObj, raiseToast } from 'src/views/utils/helper'
import { getThumbnail } from '../../utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { AppContext } from '../../context/app'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { uploadLogoFavToS3 } from 'src/s3upload/upload-logo-fav'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { DOBBY_BASE_URL } from 'src/views/utils/urls'

const IMAGE_DIMENSIONS = {
  logo: {
    width: 166,
    height: 72,
  },
  favicon: {
    width: 16,
    height: 16,
  },
}

const LogoandFav = () => {
  const { fileName, fileContents, fileType, fileSize, fileDispatch } = useFileChange()
  const dispatch = useDispatch()
  const language = localStorage.getItem('language')
  const inputLogoRef = useRef(null)
  const inputFileRef = useRef(null)
  const { setLoader, accountObj } = useContext(AppContext)

  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template

  const [imageCropModal, setImageCropModal] = useState(false)
  const [currentTime, setCurrentTime] = useState(moment(new Date()).unix())
  const [imageCropObj, setImageCropObj] = useState({
    src: '',
    crop: {
      aspect: 1,
    },
    imageName: '',
    imageType: 'image/png',
  })
  const [uploadType, setUploadType] = useState('')

  const { userSessionObj } = useContext(GlobalContext)

  const defaultLangCheck = language === accountObj?.default_language
  const updateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.UPDATE) &&
    defaultLangCheck

  const [{ loading: invalidationLoading }, invalidationCall] = useAxios(
    {
      url: `${DOBBY_BASE_URL}/${uploadType}`,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(invalidationLoading)
  }, [invalidationLoading])

  useEffect(() => {
    if (fileSize) {
      handleImageUpload()
    }
  }, [fileType, fileSize, fileSize, fileName, fileContents])

  const handleCallback = async (imageUrl, blob, imageRef) => {
    fileDispatch({
      type: 'FILE_CHANGE_SUCCESS',
      fileName: blob.name,
      fileSize: blob.size,
      fileType: blob.type,
      fileContents: blob,
    })
    setLoader(true)
    setImageCropObj({})
  }

  const invalidateCDN = async () => {
    if (uploadType) {
      let invalidateRes = await invalidationCall()
      if (invalidateRes.data.success) {
        raiseToast('success', `${uploadType} updated successfully!!`)
        return
      }
      raiseToast('error', `Something went Wrong, Please Try Again!`)
    }
  }
  const handleImageUpload = async () => {
    try {
      if (fileType && fileContents) {
        const status = await uploadLogoFavToS3(fileContents, uploadType)
        if (status?.success) {
          invalidateCDN()
        }
      }
    } catch (err) {
      dispatchAlert('danger', `Error`, `${err}`, true)
      setLoader(false)
    }
    setCurrentTime(moment(new Date()).unix())
    return false
  }

  const handleImage = async (event, imageType) => {
    const image = event.target.files[0]
    console.log('image', image)
    const imageURL = URL.createObjectURL(image)

    const img = new Image()
    img.onload = function () {
      setImageCropObj(() => ({
        crop: getImageCropObj(
          this.width,
          this.height,
          IMAGE_DIMENSIONS[imageType].width,
          IMAGE_DIMENSIONS[imageType].height,
        ),
        src: imageURL,
        imageName: image.name,
        imageType: image.type,
      }))
    }
    img.src = imageURL
    setImageCropModal(true)
  }
  const onBtnClick = (type, upload) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))

    type.current.click()
    setUploadType(upload)
  }
  return (
    <>
      <CCard style={{ minHeight: '37rem' }}>
        {/* if not custom template then render */}
        {!isCustomTemplateAllowed && (
          <>
            <CRow className="mt-5 mx-5 logo-row">
              <CCol lg="3">
                <p className="h3">Upload Logo</p>
              </CCol>
              <CCol className="d-flex flex-column logo-col mt-5" lg="4">
                <CButton
                  color="info"
                  className="text-white font-weight-bold"
                  shape="rounded-pill"
                  onClick={() => onBtnClick(inputLogoRef, 'logo')}
                  disabled={!updateAllowed}
                  style={{ pointerEvents: 'auto' }}
                  title={defaultLangCheck ? '' : 'Updating Logo Available on Default Language'}
                >
                  <FontAwesomeIcon icon={faUpload} className="mx-2" />
                  Upload Image
                </CButton>
                <CFormText className="mt-4">
                  Image format should be in .jpeg or . png. with maximum size 166 x 72 mm.
                </CFormText>
              </CCol>
              <CCol className="d-flex justify-content-end" lg="5">
                <div
                  style={{
                    border: '1px solid #707070',
                    height: '7rem',
                    width: '12.44rem',
                  }}
                  className="d-flex justify-content-center"
                >
                  {/* {isEmpty(template.logo) ? (
                <CFormText className="preview-div-text">Preview</CFormText>
              ) : ( */}
                  <div className="banner-image-div">
                    <img
                      src={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        `public/static/logo.png?v=${currentTime}`,
                      )}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = ImageNotFound
                      }}
                      alt="logo"
                      // onLoad={(e) => onImageLoad(e, 'thumbWebsite', 'website')}
                    />
                  </div>
                  {/* )} */}
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    name="logo"
                    id="logo"
                    ref={inputLogoRef}
                    onChange={(e) => handleImage(e, 'logo')}
                  />
                </div>
              </CCol>
            </CRow>
            <hr className="mx-5" />
          </>
        )}
        <CRow className="mx-5 logo-row">
          <CCol lg="3">
            <p className="h3">Upload Favicon</p>
          </CCol>
          <CCol className=" d-flex flex-column logo-col mt-5" lg="4">
            <CButton
              color="info"
              className="text-white font-weight-bold"
              shape="rounded-pill"
              onClick={() => onBtnClick(inputFileRef, `favicon`)}
              disabled={!updateAllowed}
              style={{ pointerEvents: 'auto' }}
              title={defaultLangCheck ? '' : 'Updating Favicon Available on Default Language'}
            >
              <FontAwesomeIcon icon={faUpload} className="mx-2" />
              Upload Image
            </CButton>
            <CFormText className="mt-4">
              Image format should be in .jpeg or . png. with maximum size 16 x 16 mm.
            </CFormText>
          </CCol>
          <CCol className="d-flex justify-content-end" lg="5">
            <div
              style={{
                border: '1px solid #707070',
                height: '7rem',
                width: '7rem',
                marginRight: '5.4rem',
              }}
              className="d-flex justify-content-center"
            >
              {/* {isEmpty(template.fav_icon) ? (
                <CFormText className="preview-div-text">Preview</CFormText>
              ) : ( */}
              <div className="banner-image-div">
                <img
                  src={getThumbnail(
                    userSessionObj.session_data.cf_domain_name,
                    `public/static/favicon.png?v=${currentTime}`,
                  )}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = ImageNotFound
                  }}
                  alt="favicon"
                  // onLoad={(e) => onImageLoad(e, 'thumbWebsite', 'website')}
                />
              </div>
              {/* )} */}

              <input
                type="file"
                accept="image/*"
                hidden
                name="favicon"
                id="favicon"
                ref={inputFileRef}
                onChange={(e) => handleImage(e, 'favicon')}
              />
            </div>
          </CCol>
        </CRow>
      </CCard>
      {imageCropObj.src && (
        <ImageCropper
          openModal={imageCropModal}
          imageCropObj={imageCropObj}
          closeModalHandle={() => {
            setImageCropModal(false)
            setImageCropObj({})
          }}
          handleCallback={handleCallback}
        />
      )}
    </>
  )
}

export default LogoandFav
